import React from 'react'
import PropTypes from 'prop-types'
import { Table, Button, Tooltip, Icon } from 'antd'

import Confirm from '../Confirm';

const CustomersTable = ({ data, openModal, deleteCustomer, setLoading }) => {
  const columns = [
    {
      key: 'deleteBtn',
      align: 'center',
      width: '2%',
      render: (record) => (
        <Tooltip title="Delete record" placement="right">
          <Button
            className="red-cl"
            icon="delete"
            onClick={() => Confirm(deleteCustomer, null, record.id, setLoading)}
            size="small"
          />
        </Tooltip>
      )
    },
    {
      key: 'editBtn',
      align: 'center',
      width: '2%',
      render: (record) => (
        <Tooltip title="Edit record" placement="right">
          <Button
            className="bl-cl"
            icon="edit"
            onClick={() => openModal(record)}
            size="small"
          />
        </Tooltip>
      )
    },
    {
      align: 'center',
      key: 'isApproved',
      title: 'STATUS',
      render: (data) => {
        let status = null;
        if (data.isApproved === 'PENDING APPROVAL')
          return <span>{data.isApproved}</span>;
        if (data.isApproved === 'REJECTED')
          status = <span style={{ color: '#c0392b', fontWeight: 600 }}>{data.isApproved}</span>;
        else if (
          data.isApproved === 'RECOMMENDED' ||
          data.isApproved === 'APPROVED'
        )
          status = <span style={{ color: '#27ae60', fontWeight: 600 }}>{data.isApproved}</span>;

        status = (
          <>
            {status}
            {data.comment ? 
              (
                <Tooltip title={data.comment}>
                  <Icon style={{ marginLeft: 3 }} type="info-circle" theme="twoTone" />
                </Tooltip>
              )
              : null}
          </>
        )

        return status;
      },
      filters: [
        {
          text: 'PENDING APPROVAL',
          value: 'PENDING APPROVAL',
        },
        {
          text: 'REJECTED',
          value: 'REJECTED',
        },
        {
          text: 'RECOMMENDED',
          value: 'RECOMMENDED',
        },
        {
          text: 'APPROVED',
          value: 'APPROVED',
        }
      ],
      onFilter: (value, record) => record.isApproved.indexOf(value) === 0,
      sorter: (a, b) => a.isApproved.length - b.isApproved.length,
      sortDirections: ['descend'],
      width: '2%',
    },
    {
      key: 'bi_name',
      dataIndex: 'bi_name',
      title: 'Company Name',
      align: 'center',
    },
    {
      key: 'bi_address',
      dataIndex: 'bi_address',
      title: 'Address',
      align: 'center',
      width: 300,
    },
    {
      key: 'bi_tel',
      dataIndex: 'bi_tel',
      title: 'Tel. No.',
      align: 'center',
    },
    {
      key: 'bi_email',
      dataIndex: 'bi_email',
      title: 'Email',
      align: 'center',
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      bodyStyle={{
        overflowX: 'auto',
      }}
      rowKey="id"
      size="middle"
      bordered
    />
  )
}

CustomersTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
}
export default CustomersTable
